import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/LibraryBooks';
import create from './create';
import edit from './edit';
import list from './list';

const posts: ResourceProps = {
  name: 'posts',
  icon,
  options: { label: 'Dicas/Novidades' },
  create,
  edit,
  list
};

export default posts;
